export interface ListingTimeRecord {
  jdSkuId: string
  createdAt: string
  status: string
  jdPrice: number | null
  exportDate: string
}

export interface ListingTimesData {
  schemaVersion: string
  generatedAt: string
  caliber: string
  latestExportDate: string
  records: ListingTimeRecord[]
}

let listingTimesPromise: Promise<ListingTimesData | null> | null = null

export function loadListingTimes() {
  if (!listingTimesPromise) {
    listingTimesPromise = fetch('/data/listing-times.json', { cache: 'no-store' })
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`)
        return response.json() as Promise<ListingTimesData>
      })
      .catch(() => null)
  }
  return listingTimesPromise
}
